// V3 MESO MODULES

import V3PromoBenefits from 'src/components/common/modules/v3/meso/v3-promo-benefits';
import V3IntroModule from 'src/components/common/modules/v3/meso/v3-intro-module';
import V3TextModule from 'src/components/common/modules/v3/meso/v3-text-module';
import V3PromoQuote from 'src/components/common/modules/v3/meso/v3-promo-quote';
import V3ContentTileModule from 'src/components/common/modules/v3/meso/v3-content-tile-module';
import V3ImageModule from 'src/components/common/modules/v3/meso/v3-image-module';
import V3HeroModule from 'src/components/common/modules/v3/meso/v3-hero-module';
import V3MediaGalleryComponent from 'components/common/modules/v3/meso/v3-media-gallery-component';
import V3DoubleImage from 'src/components/common/modules/v3/meso/v3-double-image';
import V3ProductIntegrationModule from './v3-product-integration-module';
import V3VideoModule from 'components/common/modules/v3/meso/v3-video-module';
import V3LogoCarouselModule from 'components/common/modules/v3/meso/v3-logo-carousel-module';
import V3ImageContrastModule from 'components/common/modules/v3/meso/v3-image-contrast-module';
import V3CompetitionEntryForm from 'src/components/common/modules/v3/meso/v3-competition-entry-form';
import V3ItineraryMapModule from 'src/components/common/modules/v3/meso/v3-itinerary-map-module';
import V3HotelDeals from 'src/components/common/modules/v3/meso/v3-hotel-deals';
import V3MesoVideoHeroModule from './v3-meso-video-hero-module';

type ModulesType = {
  [key: string]: () => any;
};

const v3MesoModules: ModulesType = {
  v3HeroModule: () => V3HeroModule,
  v3IntroductionModule: () => V3IntroModule,
  v3TextModule: () => V3TextModule,
  v3PromoBenefits: () => V3PromoBenefits,
  v3BenefitsPanelModule: () => V3PromoBenefits,
  // v3BookingWidget: () => V3BookingWidget,
  v3doubleImageModule: () => V3DoubleImage,
  v3QuoteModule: () => V3PromoQuote,
  v3ProductIntegrationModule: () => V3ProductIntegrationModule,
  v3VideoModule: () => V3VideoModule,
  v3ContentTileModule: () => V3ContentTileModule,
  v3GalleryCarouselModule: () => V3MediaGalleryComponent,
  v3LogoCarouselModule: () => V3LogoCarouselModule,
  v3ImageModule: () => V3ImageModule,
  v3ImageContrastModule: () => V3ImageContrastModule,
  v3EntryFormModule: () => V3CompetitionEntryForm,
  v3ItineraryMapModule: () => V3ItineraryMapModule,
  // v3HotelDealsModule: () => V3HotelDeals,
  v3TabbedDealsModule: () => V3HotelDeals,
  v3HeroCinemaModule: () => V3MesoVideoHeroModule,
};

export default v3MesoModules;
